import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 9 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 6\" id=\"icon-triangle\"><path d=\"M4.677 6L9 0H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol